<template>
  <div class="singIn verfication">
    <div class="logo">
      <div class="backIcon">
        <i
          class="el-icon-back cursor"
          @click="goBack"></i>
      </div>
      <div class="tvuLogo">
        <!-- <img src="./../assets/img/TVU networks Copy.png" alt=""> -->
      </div>
    </div>
    <div class="formBody">
      <div class="singInLabel">
        <p class="tvuSingIn">{{$t('lang.enterCode')}}</p>
        <p class="tvuDescribe">{{$t('lang.verfyInfo')}}
          <span class='emailName'>{{userInfo.email}}.</span>
        </p>
      </div>
      <div class="singInForm">
        <div class="exchange emailArea">
          <div class="tip">{{$t('lang.entercode')}}</div>
          <el-input
            class="input"
            v-model.trim="email"
            :placeholder="$t('lang.entercode')"
            @keyup.enter.native="nextOpaertaion"
            @focus="focusInput"
            @blur="blurInput(1)"></el-input>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span
              v-show="isShowTip"
              class="warningTip">{{$t('lang.vcodeFormat')}}</span>
          </div>
        </div>
        <!-- 忘记密码页面进入，显示图形验证码 -->
        <div
          class="exchange vertical"
          v-if='!flag'>
          <el-input
            v-model.trim="vcode"
            tabindex='3'
            class="vcodeInput"
            maxlength="4"
            :placeholder="$t('lang.vcodePlaceholder')"
            v-repeat-enter="{event:nextOpaertaion}"></el-input>
          <div class="vcode">
            <img
              class="cursor"
              :src="'data:image/jpeg;base64,'+imgUrl"
              alt=""
              @click='getVcode'>
          </div>
          <!-- <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">Incorrect verification code</span>
          </div> -->
        </div>
        <div :class="[isWaiting?'waitingStyle':'','confirmArea'] ">
          <span
            class="cursor createAccount"
            @click="sendEmail">{{$t('lang.resendEmail')}}</span>
          <!-- :disabled='isDisabeBtn' -->
          <el-button
            class="confirmBtn cursor"
            :disabled='isDisabeBtn'
            v-repeat-click="{event:nextOpaertaion}"
            :loading="isLoading">{{$t('lang.next')}}
            <i
              v-show='isWaiting'
              class='el-icon-refresh-right'></i>
          </el-button>
        </div>
      </div>
    </div>
    <div class="footer">
      <transition name="el-fade-in">
        <div
          v-show="isShowTip"
          class="box">{{$t('lang.endingTip')}}</div>
      </transition>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

import { mapState } from 'vuex'

export default {
  name: 'CreateAccount',
  data () {
    return {
      email: '',
      isDisabeBtn: true,
      emailErrorTip: '',
      isShowTip: false,
      isWaiting: false,
      isLoading: false,
      flag: true,
      vcode: '',
      imgUrl: '',
      key: '',
      userInfo: {}
    }
  },
  mounted () {
    this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    // 忘记密码进入的时候调验证码，并显示图形验证码
    this.flag = this.$route.query.verifyFlag == 1
    if (!this.flag) {
      this.getVcode()
    }
  },
  watch: {
    email: function (newVal) {
      if ($('.emailArea').hasClass('errorInput')) {
        $('.emailArea').removeClass('errorInput')
      }
      // if (this.flag) {
      //   if (!newVal) {
      //     this.isDisabeBtn = true
      //   } else {
      //     this.isDisabeBtn = false
      //     this.isShowTip = false
      //   }
      // } else {
      //   if (!newVal || !this.vcode) {
      //     this.isDisabeBtn = true
      //   } else {
      //     this.isDisabeBtn = false
      //     this.isShowTip = false
      //   }
      // }

      if (this.flag) {
        this.isDisabeBtn = !newVal
        newVal && (this.isShowTip = false)
        return
      }
      const flag = !newVal || !this.vcode
      this.isDisabeBtn = flag
      !flag && (this.isShowTip = false)
    },
    vcode: function (newVal) {
      if ($('.vertical').hasClass('errorInput')) {
        $('.vertical').removeClass('errorInput')
      }
      if (!newVal || !this.email) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    }

  },
  computed: {
    // userInfo () {
    //   return this.$store.state.userInfo
    // },
    location () {
      return this.$store.state.location
    },
    ...mapState({
      httpsFlag: 'httpsFlag'
    })
  },
  methods: {
    getVcode () {
      this.axios.get(
        '/userGroup/user-group/login/getVCode',
        {
          width: 80,
          height: 40
        }
      ).then((res) => {
        // if(res.data.errorCode == '0x0'){
        // 注册成功
        if (res.data.errorCode == '0x0') {
          this.imgUrl = res.data.result.vCode
          this.$store.state.key = res.data.result.key
          this.key = res.data.result.key
          // let host = window.location.host;
          // if(host.indexOf('.'+res.data.result.domain+'.')>-1){
          // 	let lastDomain = host.split('.').slice(-1);
          // 	this.domainName = res.data.result.domain + '.' + host.split('.').slice(-1);
          // }else{
          // 	this.domainName = res.data.result.domain;
          // }
          // url上截取domain
          // let localUrl = window.location.href
          // let str1 = localUrl.split(".")[1]
          // let str2 = localUrl.split(".")[2].split("/")[0]
          const localUrl = window.location.hostname
          const str1 = localUrl.split('.')[1]
          const str2 = localUrl.split('.')[2]

          this.domainName = `.${str1}.${str2}`

          const exp = new Date()

          exp.setTime(exp.getTime() - 1)
          window.document.cookie = `SID=;path=/;domain=${this.domainName};expires=${exp.toGMTString()};${this.httpsFlag ? 'Secure=true;' : ''}`
          window.document.cookie = `SID=;path=/;domain=${this.domainName};expires=${exp.toGMTString()};`
          // window.document.cookie = `tvutag=;path=/;domain=${this.domainName};expires=${exp.toGMTString()}`;
          this.tagKeys.forEach((item) => {
            window.document.cookie = `${item}=;path=/;domain=${this.domainName};expires=${exp.toGMTString()}`
          })
        } else {
          this.$message({
            message: this.$t('lang.error80943601'),
            type: 'error',
            duration: 3000
          })
        }
      }).catch(() => {
      })
    },
    sendEmail () {
      // ga('send', 'event', 'newUserService-verify-resendEmail', 'click')
      gtag('event', 'newUserService-verify-resendEmail')
      if (this.isWaiting) {
        return
      }
      this.isWaiting = true
      this.isShowTip = true
      const timer = setTimeout(() => {
        this.isShowTip = false
        clearTimeout(timer)
      }, 3000)
      // flag true从用户注册过来的
      if (this.flag) {
        this.axios.post(
          '/userGroup/user-group/login/resendRGEmailCode',
          this.qs.stringify({
            email: this.userInfo.email,
            url: this.location
          }),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        ).then((res) => {
          // if(res.data.errorCode == '0x0'){
          // 注册成功
          this.isWaiting = false
          // this.isShowTip = false;
          if (res.data.errorCode != '0x0') {
            this.$message({
              message: res.data.errorInfo,
              type: 'error',
              duration: 3000
            })
          }
        }).catch()
      } else {
        this.axios.post(
          '/userGroup/user-group/login/forgotPassword',
          this.qs.stringify({
            email: this.userInfo.email,
            flag: 1,
            url: this.location
          }),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        ).then((res) => {
          // if(res.data.errorCode == '0x0'){
          // 注册成功
          this.isWaiting = false
          // this.isShowTip = false;
          if (res.data.errorCode == '0x0') {
            // this.$store.state.userInfo.email = this.email;
            // this.$router.push('/vericomfy');
          } else if (res.data.errorCode == '80943701') {
            this.$message({
              message: this.$t('lang.error80943701'),
              type: 'error',
              duration: 3000
            })
          } else if (res.data.errorCode == '80943702') {
            this.$message({
              message: this.$t('lang.error80943702'),
              type: 'error',
              duration: 3000
            })
          }
        }).catch()
      }

      // let timer = setTimeout(()=>{
      // 	this.isWaiting =  false;
      // 	this.isShowTip = false;
      // },3000)
    },
    goBack () {
      // ga('send', 'event', 'newUserService-verify-goBack', 'click')
      gtag('event', 'newUserService-verify-goBack')
      this.$router.go(-1)
    },
    nextOpaertaion () {
      // this.isShowTip = !this.isShowTip;
      // this.$router.push('/register')
      // if (!this.email) {
      //   this.isDisabeBtn = true
      //   return
      // }
      // this.isDisabeBtn = false
      this.sendVerifyEmail()
    },
    focusInput (event) {
      $(event.target).parent().prev('.tip').css({
        display: 'inline-block',
        color: 'rgba(51,171,79,1)'
      })
    },
    blurInput (num) {
      // num ,1代表email失去焦点，2代表companyName失去焦点
      $(event.target).parent().prev('.tip').css('color', 'rgba(153,153,153,1)')
      if (num == 1) {
        this.email ? '' : $(event.target).parent().prev('.tip').css('display', 'none')
      }
    },
    sendVerifyEmail () {
      if (!this.email || (!this.flag && !this.vcode) || this.isLoading) {
        return
      }
      this.isLoading = true
      // flag true从用户注册过来的
      if (this.flag) {
        this.axios.post(
          '/userGroup/user-group/login/verify',
          this.qs.stringify({
            userId: this.userInfo.id,
            verifyCode: this.email
          }),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        ).then((res) => {
          // if(res.data.errorCode == '0x0'){
          // 验证成功跳转完善信息页面
          this.isLoading = false
          if (res.data.errorCode == '80943203') {
            this.$router.push('/register')
          } else if (res.data.errorCode == '80943202') { // 验证码错误
            this.$message({
              message: this.$t('lang.error80943402'),
              type: 'error',
              duration: 3000
            })
          } else if (res.data.errorCode == '80943201') { // 用户不存在
            this.$message({
              message: this.$t('lang.error80943401'),
              type: 'error',
              duration: 3000
            })
          }
        }).catch()
      } else {
        this.axios.post(
          '/userGroup/user-group/login/checkVerifyCode',
          {
            email: this.userInfo.email,
            verifyCode: this.email,
            imgCode: this.vcode,
            key: this.key
          },
          {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }
        ).then((res) => {
          // if(res.data.errorCode == '0x0'){
          // 验证成功跳转完善信息页面
          this.isLoading = false
          if (res.data.errorCode == '80943403') {
            this.$store.state.emailCode = this.email
            this.$router.push('/changePsw')
          } else if (res.data.errorCode == '80943402') { // 验证码错误
            this.$message({
              message: this.$t('lang.error80943402'),
              type: 'error',
              duration: 3000
            })
            this.getVcode()
          } else if (res.data.errorCode == '80943401') { // 用户不存在
            this.$message({
              message: this.$t('lang.error80943401'),
              type: 'error',
              duration: 3000
            })
            this.getVcode()
          } else if (res.data.errorCode == '80943405') {
            this.$message({
              message: this.$t('lang.error809434051') + res.data.result + this.$t('lang.error809434052'),
              type: 'error',
              duration: 3000
            })
            this.getVcode()
          } else if (res.data.errorCode == '80943701') {
            this.$message({
              message: this.$t('lang.errorVcode1'),
              type: 'error',
              duration: 3000
            })
            this.getVcode()
          } else if (res.data.errorCode == '80943702') {
            this.$message({
              message: this.$t('lang.errorVcode2'),
              type: 'error',
              duration: 3000
            })
            this.getVcode()
          }
        }).catch()
      }
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     if (from.path == '/create') {
  //       vm.flag = true
  //     } else {
  //       vm.flag = false
  //     }
  //   })
  // },
  filters: {
    getStrength (val) {
      switch (val) {
        case 2:
          return 'Low'
        case 4:
          return 'Middle'
        case 6:
          return 'High'
        default:
          break
      }
    }
  }
}
</script>
<style scoped>
.tvuDescribe {
  word-break: break-all;
}
</style>
